import PriceParity from '../src/PriceParity/index.tsx';
export default PriceParity;
